<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M16.4062 1.5625C12.523 1.5625 9.375 4.7105 9.375 8.59375C9.375 9.00388 9.4102 9.40641 9.47791 9.79833C9.5479 10.2034 9.44457 10.5443 9.24758 10.7413L2.47779 17.5111C1.89174 18.0972 1.5625 18.892 1.5625 19.7208V22.6562C1.5625 23.0877 1.91228 23.4375 2.34375 23.4375H6.25C6.68147 23.4375 7.03125 23.0877 7.03125 22.6562V21.0938H8.59375C9.02522 21.0938 9.375 20.744 9.375 20.3125V18.75H10.9375C11.1447 18.75 11.3434 18.6677 11.4899 18.5212L14.2587 15.7524C14.4557 15.5554 14.7966 15.4521 15.2017 15.5221C15.5936 15.5898 15.9961 15.625 16.4062 15.625C20.2895 15.625 23.4375 12.477 23.4375 8.59375C23.4375 4.7105 20.2895 1.5625 16.4062 1.5625ZM16.4062 4.6875C15.9748 4.6875 15.625 5.03728 15.625 5.46875C15.625 5.90022 15.9748 6.25 16.4062 6.25C17.7007 6.25 18.75 7.29933 18.75 8.59375C18.75 9.02522 19.0998 9.375 19.5312 9.375C19.9627 9.375 20.3125 9.02522 20.3125 8.59375C20.3125 6.43639 18.5636 4.6875 16.4062 4.6875Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgKey',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>